import React from 'react';

const DoorenterIcon = ({ width = 24, height = 24, color = '#0F7F85' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13 22" fill="none">
      <path
        d="M12.0219 0.02766C12.5622 0.0290176 13 0.481522 13 1.03915V20.9885C12.9998 21.547 12.5611 22 12.02 22H0.987632C0.446552 22 0.00786216 21.547 0.00765607 20.9885L0 1.0115C-1.30176e-07 0.742876 0.103839 0.485105 0.288059 0.29535C0.472233 0.105778 0.721793 -0.000522662 0.98189 1.93247e-06L12.0219 0.02766ZM1.96761 19.977H11.04V2.04769L1.95995 2.02497L1.96761 19.977ZM6.85983 13.1494V11.1264C6.85983 10.5678 7.29859 10.1149 7.83981 10.1149C8.38104 10.1149 8.81979 10.5678 8.81979 11.1264V13.1494C8.81978 13.7081 8.38103 14.1609 7.83981 14.1609C7.29859 14.1609 6.85984 13.7081 6.85983 13.1494Z"
        fill={color}
      />
    </svg>
  );
};

export default DoorenterIcon;
